import { useToggleSourceStatus } from '../hooks/useToggleSourceStatus';
import { ConfirmDialog } from '@/shared/components/ahkinia/ConfirmDialog/ConfirmDialog';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

interface ToggleSourceModalProps {
  sourceId: string;
  sourceName: string;
  currentStatus: boolean;
  open: boolean;
  onClose: () => void;
}

export function ToggleSourceModal({
  sourceId,
  sourceName,
  currentStatus,
  open,
  onClose,
}: ToggleSourceModalProps) {
  const { toggleStatus, isToggling } = useToggleSourceStatus();

  const isEnabling = !currentStatus;

  const handleConfirm = () => {
    toggleStatus(
      { id: sourceId, isEnabled: !currentStatus },
      {
        onSuccess: () => {
          Notification.success({
            title: isEnabling
              ? 'Fuente habilitada exitosamente'
              : 'Fuente deshabilitada exitosamente',
          });
          onClose();
        },
      },
    );
  };

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(v) => !v && onClose()}
      title={isEnabling ? 'Habilitar fuente' : 'Deshabilitar fuente'}
      description={
        <span data-testid="toggle-source-confirmation-text">
          {isEnabling
            ? `¿Estás seguro de habilitar la fuente "${sourceName}"? Se reanudará la ingesta de datos.`
            : `¿Estás seguro de deshabilitar la fuente "${sourceName}"? Se detendrá la ingesta de datos.`}
        </span>
      }
      onConfirm={handleConfirm}
      confirmLabel={isEnabling ? 'Habilitar' : 'Deshabilitar'}
      confirmLoadingLabel={isEnabling ? 'Habilitando...' : 'Deshabilitando...'}
      isPending={isToggling}
      data-testid="toggle-source-modal"
    />
  );
}
